import styled from 'styled-components'

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const TermTitle = styled.h2`
  margin: 0;
  color: ${props => props.theme.palette.blue.main};
  font-family: Gilroy;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;

  @media (max-width: 767px) {
    font-size: 24px;
  }
`
